import eyeExam from "../img/services/testing.jpg";
import diagnosis from "../img/services/diagnosis.jpg";
import contactlense from "../img/services/contactlense.jpg";
import eyewears from "../img/eyewear.jpg";
import familycare from "../img/services/familycare.jpg";
import eyeinfection from "../img/services/eyeinfection.jpg";
import clinic1 from "../img/clinic/clinic1.jpg";
import clinic2 from "../img/clinic/clinic5.jpg";
import clinic3 from "../img/clinic/clinic7.jpg";
import gallary1 from "../img/gallary/gallary1.jpg";
import gallary2 from "../img/gallary/gallary2.jpg";
import gallary4 from "../img/gallary/gallary4.jpg";
import gallary5 from "../img/gallary/gallary5.jpg";
import gallary6 from "../img/gallary/gallary6.jpg";
import gallary7 from "../img/gallary/gallary7.jpg";
import gallary9 from "../img/gallary/gallary9.jpg";
import gallary10 from "../img/gallary/gallary10.jpg";
import gallary11 from "../img/gallary/gallary11.jpg";
import gallary12 from "../img/gallary/gallary12.jpg";
import call from "../img/social/call.png";
import fb from "../img/social/fb.webp";
import gmail from "../img/social/gmail.png";
import insta from "../img/social/insta.png";
import wa from "../img/social/whatsapp.png";
import yt from "../img/social/yt.png";
import exam1 from "../img/exam/exam1.jpg";
import exam2 from "../img/exam/exam2.jpg";
import exam3 from "../img/exam/exam3.jpg";
import exam4 from "../img/exam/exam4.jpg";
import exam5 from "../img/exam/exam5.jpg";
import exam6 from "../img/exam/exam6.jpg";
import exam7 from "../img/exam/exam7.jpg";
import visual from "../img/exam/visual-acuity-test.webp";
import refraction from "../img/exam/refraction-test.jpg";
import muscle from "../img/exam/eye-muscle-test.jpg";
import pressure from "../img/exam/eye-pressure-test.jpg";
import extra from "../img/exam/additional-test.jpg";
import highIndexLens from "../img/contact-lens/types/high-index-lens.png";
import progressiveLens from "../img/contact-lens/types/progressive-lens.jpg";
import bifocalLens from "../img/contact-lens/types/bifocal-lens.jpg";
import antiReflect from "../img/contact-lens/types/anti-reflec.jpg";
import photochromic from "../img/contact-lens/types/photochromic.jpg";
import blueCut from "../img/contact-lens/types/blue-cut-lens.jpg";
import lens1 from "../img/contact-lens/lens1.jpg";
import lens2 from "../img/contact-lens/lens2.jpg";
import lens3 from "../img/contact-lens/lens3.jpg";
import lens4 from "../img/contact-lens/lens4.jpg";
import sunglass1 from "../img/sunglasses/sunglass1.jpg";
import sunglass2 from "../img/sunglasses/sunglass2.jpg";
import sunglass3 from "../img/sunglasses/sunglass3.jpg";
import sunglass4 from "../img/sunglasses/sunglass4.jpg";
import sunglass5 from "../img/sunglasses/sunglass5.jpg";
import sunglass6 from "../img/sunglasses/sunglass6.jpg";
import sunglass7 from "../img/sunglasses/sunglass7.jpg";
import sunglass8 from "../img/sunglasses/sunglass8.jpg";
import sunglass9 from "../img/sunglasses/sunglass9.jpg";
import sunglass10 from "../img/sunglasses/sunglass10.jpg";
import eyeglass1 from "../img/eyeglass/eyeglass1.jpg";
import eyeglass2 from "../img/eyeglass/eyeglass2.jpg";
import eyeglass3 from "../img/eyeglass/eyeglass3.jpg";
import eyeglass4 from "../img/eyeglass/eyeglass4.jpg";
import eyeglass5 from "../img/eyeglass/eyeglass5.jpg";
import eyeglass6 from "../img/eyeglass/eyeglass6.jpg";
import eyeglass7 from "../img/eyeglass/eyeglass7.jpg";
import eyeglass9 from "../img/eyeglass/eyeglass9.jpg";
import eyeglass10 from "../img/eyeglass/eyeglass10.jpg";
import eyeglass11 from "../img/eyeglass/eyeglass11.jpg";
import eyeglass12 from "../img/eyeglass/eyeglass12.jpg";
import eyeglass13 from "../img/eyeglass/eyeglass13.jpg";
import eyeglass14 from "../img/eyeglass/eyeglass14.jpg";
import eyeglass15 from "../img/eyeglass/eyeglass15.jpg";

export const importUrl = {
  eyeExam,
  diagnosis,
  contactlense,
  eyewears,
  familycare,
  eyeinfection,
  clinic1,
  clinic2,
  clinic3,
  gallary1,
  gallary2,
  gallary4,
  gallary5,
  gallary6,
  gallary7,
  gallary9,
  gallary10,
  gallary11,
  gallary12,
  call,
  fb,
  gmail,
  insta,
  wa,
  yt,
  exam1,
  exam2,
  exam3,
  exam4,
  exam5,
  exam6,
  exam7,
  visual,
  refraction,
  muscle,
  pressure,
  extra,
  highIndexLens,
  progressiveLens,
  bifocalLens,
  antiReflect,
  photochromic,
  blueCut,
  sunglass1,
  sunglass2,
  sunglass3,
  sunglass4,
  sunglass5,
  sunglass6,
  sunglass7,
  sunglass10,
  sunglass8,
  sunglass9,
  lens1,
  lens2,
  lens3,
  lens4,
  eyeglass1,
  eyeglass2,
  eyeglass3,
  eyeglass4,
  eyeglass5,
  eyeglass6,
  eyeglass7,
  eyeglass9,
  eyeglass10,
  eyeglass11,
  eyeglass12,
  eyeglass13,
  eyeglass14,
  eyeglass15,
};
